module.exports = __webpack_public_path__ + "static/media/400049_01.67d7473c.png";